import styled from "styled-components";

export const ConfirmationRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 32px;

  button {
    width: 100%;
  }
`;

export const ConfirmationLabel = styled.p`
  line-height: ${({ theme }) => theme.fonts.lineHeights.xs};
  font-size: ${({ theme }) => theme.fonts.sizes.xxs};
  font-weight: ${({ theme }) => theme.fonts.weights.normal};
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
  margin: 25px 0;
`;

export const ConfirmationPopupWrapper = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 2;
  background-color: ${({ theme }) => theme.colors.background};
  border: ${({ theme }) =>
    `${theme.border.thin} solid ${theme.colors.primary}`};
  border-radius: ${({ theme }) => `${theme.borderRadius.l}`};
`;

export const CloseConfirmationPopupButton = styled.button`
  padding: 0;
  margin: 0;
  border: 0;
  outline: 0;
  background: transparent;
  position: absolute;
  right: 15px;
  top: 15px;
  cursor: pointer;
`;
